<template>
  <div class="title_wrap">
    <h1 class="contents_title rb"
    @touchstart="OnTouchStart($event)"
    @touchmove="OnTouchMove($event)"
    @touchend="OnTouchEnd()"
    >{{ title }}</h1>
    <button @click="showDayContents()" :style="{ transform: 'rotate(' + arrowRotate() + 'deg)' }" type="button" class="toggle_button">
      <img :src="require('@/assets/images/fanclub/notes/arrow.svg')" alt="">
    </button>
  </div>
</template>

<script>
import Height from '@/model/notes/height';

export default {
  props: ['title'],
  data() {
    return {
      isShowDayContents: false,
      swipe: {
        flag: false,
        threshold: 60,
        start: {
          y: 0
        },
        current: {
          y: 0
        },
        distance: {
          y: 0
        },
      },
    }
  },
  methods: {
    arrowRotate() {
      return this.isShowDayContents ? '180' : '0';
    },
    showDayContents() {
      if(!this.isShowDayContents) {
        // Height.setTranslate('-' + Height.getShowContentsHeight());
        Height.toggleContents(false);
        this.isShowDayContents = true;
      } else {
        this.isShowDayContents = false;
        // Height.setScrollPosition();
        Height.toggleContents(true);
      }
    },

    getShowContentsHeight() {
      let showContents = document.getElementById('js-show-contents');
      return showContents.clientHeight;
    },

    OnTouchStart(e) {
      this.swipe.flag = true;
      this.swipe.start.y = e.touches[0].pageY;
    },
    OnTouchMove(e) {
      this.swipe.current.y = e.touches[0].pageY;
      this.swipe.distance.y = this.swipe.current.y - this.swipe.start.y;

      if(!this.isShowDayContents) {
        // 閉じている状態の時は要素が下に移動しない
        if(Number(this.swipe.distance.y) > 0) return;
      }
      if(this.isShowDayContents) {
        // 開いている状態の時は要素が上に移動しない
        if(Number(this.swipe.distance.y) < 0) return;
      }

      let translate = document.getElementById('js-note-audio');
      let style = window.getComputedStyle(translate);
      let value = style.getPropertyValue('transform');
      let split = value.split(',');
      let transformValue = split[split.length - 1].replace(')', '');
      Height.setTranslate(Number(transformValue) + Number(this.swipe.distance.y));

    },
    OnTouchEnd() {
      this.swipe.flag = false;
      if(!this.isShowDayContents) {
        if(this.swipe.distance.y < -50) {
          this.showDayContents();
          return;
        }
        // 開かなかった場合最初の位置に戻す
        Height.toggleContents(true);
      }

      if(this.isShowDayContents) {
        if(this.swipe.distance.y > 50) {
          this.showDayContents();
          return;
        }
        // 閉じなかった場合最初の位置に戻す
        Height.toggleContents(false);
      }
    },
  }
}
</script>

<style lang="css" scoped>
.title_wrap {
  position: relative;
}
.toggle_button {
  background: transparent;
  border: none;
  bottom: 0;
  margin: auto;
  max-width: 20px;
  position: absolute;
  padding: 0;
  top: 0;
  right: 0;
}

.contents_title {
  color: #fff;
  font-size: 18px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/AudioTitle.vue